// import { faBold } from '@fortawesome/free-solid-svg-icons';
// import { withStyles } from '@material-ui/core/styles';
import { grey } from '@material-ui/core/colors';
// const useStyles = makeStyles((theme) => ({
export const styles = (theme) => ({
  shapeCircle: {
    width: 40,
    height: 40,
    borderRadius: '50%',
    backgroundColor: '#033375',
    color: '#fff',
  },

  titlePage: {
    fontFamily: 'Kanit',
    fontSize: 24,
    fontWeight: 400,
  },
});
